export const TEXTS = {
    NOT_FOUND: `No results found for “{0}”`,
};
